import React, { Suspense, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { LangContext } from "../../../modules/context"
import { translator, chatbot_setting } from "../../../data/config/brandSetup"
import { CHATBOT_LOAD_TYPE, TYPES } from "../../../data/config/constants"
import chatbotStyle from "../../../data/config/chatbotStyle"
import LottieContainer from "../lottiecontainer"
import { store } from "../../../index"
import actionTypes from "../../../data/redux/actiontypes"

const CloseTrigger = React.lazy(() => import("../closetrigger"))

const RenderTrigger = ({ src, lang }) => {
  switch (chatbot_setting.trigger_type_in_floating_menu) {
    case TYPES.LOTTIE:
      return <LottieContainer />
    case TYPES.VIDEO:
      return (
        <video
          src={translator.assets[lang].videoTrigger}
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          className="ori-full-parent-height"
        />
      )
    default:
      return <img src={src} alt="trigger" className="ori-full-parent-height" />
  }
}

const FloatingTrigger = ({ src, lang, onClick }) => (
  <div
    className={`ori-fixed ori-z-index-99991 ori-cursor-ptr ${chatbotStyle.floatingTriggerClass}`}
    onClick={onClick}
  >
    <RenderTrigger src={src} lang={lang} />
  </div>
)

const FloatingMenu = ({
  notification_count,
  is_chat_open,
  unseen_messages,
  openChatbot,
}) => {
  const [showMenu, setShowMenu] = useState(false)

  const handleTriggerClick = () => {
    if (
      chatbot_setting.notification_bot.visibility &&
      unseen_messages.length > 0 &&
      chatbot_setting.floating_menu_type !== TYPES.CIRCULAR
    )
      openChatbot(true)
    else {
      setShowMenu(true)
      store.dispatch({
        type: actionTypes.UPDATE_CHATS_STATE,
        payload: {
          is_floating_menu_open: true
        }
      })
    }
  }

  const handleMenuClose = () => {
    store.dispatch({
      type: actionTypes.UPDATE_CHATS_STATE,
      payload: {
        is_floating_menu_open: false
      }
    })
    setShowMenu(false)
  }

  return (
    <LangContext.Consumer>
      {(lang) => {
        if (chatbot_setting.floating_menu_type === TYPES.CIRCULAR)
          return (
            <>
              {showMenu ? (
                <Suspense>
                  <CloseTrigger
                    className="floatingTriggerMenuClose"
                    onClick={() => handleMenuClose()}
                  >
                    {chatbot_setting.floating_menu_options.map(
                      (item, index) => (
                        <div
                          key={index}
                          className={`ori-absolute ori-z-index-99991 ori-cursor-ptr ${chatbotStyle.floatingCircularItemClass} ${item.className}`}
                          onClick={(e) => {
                            e.stopPropagation()
                            if (item.action) item.action()
                            else openChatbot(true)
                            handleMenuClose()
                          }}
                        >
                          <div className="floatingCircularItemTitle">
                            {item.title}
                          </div>
                          {item.type === "chatbot" &&
                            notification_count > 0 && (
                              <span className="ori-absolute ori-align-top ori-align-right ori-bg-green ori-font-white ori-pad-3 ori-border-radius-10 ori-font-xs">
                                {notification_count}
                              </span>
                            )}
                          <div className="floatingCircularItemIcon">
                            {item.icon}
                          </div>
                        </div>
                      )
                    )}
                  </CloseTrigger>
                </Suspense>
              ) : (
                <FloatingTrigger
                  src={translator.assets[lang].trigger}
                  lang={lang}
                  onClick={handleTriggerClick}
                />
              )}
            </>
          )
        else if (chatbot_setting.floating_menu_type === TYPES.DEFAULT)
          return (
            <>
              {showMenu ? (
                <>
                  <div
                    className={`ori-fixed ori-z-index-99991 ${chatbotStyle.floatingListClass}`}
                  >
                    {chatbot_setting.floating_menu_options.map(
                      (item, index) => (
                        <div
                          key={index}
                          className={`ori-relative ori-flex-row ori-flex-jfe ori-cursor-ptr floatingItem ${item.className}`}
                          onClick={() => {
                            handleMenuClose()
                            if (item.action) item.action()
                            else openChatbot(true, CHATBOT_LOAD_TYPE.TRIGGER)
                          }}
                        >
                          <div className="floatingItemTitle">{item.title}</div>
                          {item.type === "chatbot" &&
                            notification_count > 0 && (
                              <span className="ori-absolute ori-bg-green ori-font-white ori-pad-3 ori-border-radius-10 ori-font-xs">
                                {notification_count}
                              </span>
                            )}
                          <div className="floatingItemIcon">{item.icon}</div>
                        </div>
                      )
                    )}
                  </div>
                  <Suspense fallback={null}>
                    <CloseTrigger
                      onClick={() => {
                        handleMenuClose()
                        openChatbot(false)
                      }}
                    />
                  </Suspense>
                </>
              ) : (
                !is_chat_open && (
                  <FloatingTrigger
                    src={translator.assets[lang].trigger}
                    lang={lang}
                    onClick={handleTriggerClick}
                  />
                )
              )}
            </>
          )
        return null
      }}
    </LangContext.Consumer>
  )
}

const mapStateToProps = (state) => {
  return {
    is_chat_open: state.chat_details.is_chat_open,
    notification_count: state.chat_details.notification_count,
    unseen_messages: state.chat_details.unseen_messages,
  }
}

FloatingMenu.propTypes = {
  openChatbot: PropTypes.func.isRequired,
  is_chat_open: PropTypes.bool,
  notification_count: PropTypes.number,
}

export default connect(mapStateToProps)(FloatingMenu)
